<template>
    <div>
        <table v-if="deviceModels.length > 0 " class="table table-striped table-bordered">
            <thead>
            <th>id</th>
            <th>Name</th>
            <th>Type</th>
            <th>Generation</th>
            <th>Test Category</th>
            <th>Description</th>
            </thead>
            <tbody>
            <tr v-for="(deviceModel,index) in deviceModels">
                <td valign="middle" align="center">{{deviceModel.id}}</td>
                <td valign="middle">
                    <img v-if="deviceModelsImages[deviceModel.id]" :src="returnedUrl(deviceModelsImages[deviceModel.id])" width="50" height="50" />
                    {{deviceModel.name}}
                </td>
                <td valign="middle">{{deviceModel.gateway?'gateway':'node'}}</td>
                <td valign="middle">{{deviceModel.gateway?'GW':'Device'}} Gen {{deviceModel.generation}}</td>
                <td valign="middle">{{testTypes[deviceModel.test_type].name}}</td>
                <td valign="middle">{{deviceModel.description}}</td>
            </tr>
            </tbody>
        </table>
    </div>
</template>
<style scoped>
    .table td, .table th {
        padding: 5px;
        vertical-align: initial;
    }
</style>
<script>
import Vue from 'vue';
import DeviceModel from '@/app-model/deviceModel.js';

export default {
    components: {
    },
    data () {
      return {
        deviceModels: [],
        deviceModelsImages: {},
        testTypes: {},
      }
    },
    created () {
      this.deviceModelTools.all({store: this.$store}).then(({response, result: {device_models, firmware_key, generations, firmware_category, test_types}}) => {
        switch (response.status) {
          case 200:
            this.deviceModels = device_models;
            for (let i = 0; i < test_types.length; i++) {
              Vue.set(this.testTypes, test_types[i].id, test_types[i]);
            }
            for (let i = 0; i < this.deviceModels.length; i++) {
              this.fetchDeviceModelImages(this.deviceModels[i].id);
            }
            break;
          case 422:
            alert(response.data)
        }
      });
    },
    computed: {
      deviceModelTools: function () {
        return new DeviceModel;
      },
    },
    methods: {
      returnedUrl (fileObject) {
        return `${fileObject.file.path}?token=${encodeURI(fileObject.file.token)}`;
      },
      fetchDeviceModelImages(id) {
        this.$store.dispatch('apiResult', {
          method: 'GET',
          path: `api/device-models/${id}/files?transform=device_model_small`,
          path_template: '/api/device-models/{device_model_id}/files',
        }).then(response => {
          switch (response.status) {
            case 200:
              Vue.set(this.deviceModelsImages, id, response.data.data.files[0]);
              break;
          }
        });
      },
    }
  }
</script>